import { defineStore } from "pinia";
import { ref } from "vue";

import { useQuery } from "@/composables/useZero";
import { queries } from "@loanlink-nl/zero";

export const useMainStore = defineStore("main", () => {
	const leningdelenTeHoog = ref(false);
	const showOptimalHeights = ref(false);

	const { data: agencyData } = useQuery(queries.agency.current());

	function $reset() {
		leningdelenTeHoog.value = false;
		showOptimalHeights.value = false;
	}

	return {
		agency: agencyData,

		leningdelenTeHoog,
		showOptimalHeights,

		$reset,
	};
});
